import { QueryFunctionContext } from "@tanstack/react-query";
import { encrypt } from "./token";

const domain = (globalThis.constructor.name === "Window" 
  && location.hostname === "localhost" ? "http://localhost:8080" : "/api")
const URL = domain + "/cidadao/";

export default async function getCidadao({queryKey}: QueryFunctionContext) {
    if(queryKey[1] === "") return null
    // se domain for "/api" (produção o desenvol), criptografar id.
    // no local, usar id direto para funcionar com o json-server.
    const id = domain === "/api" ? await encrypt(queryKey[1] as string) : queryKey[1] as string
    try {
        const response = await fetch(`${URL}${id}`);
        if (!response.ok) {
          return null;
        }
        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error fetching citizen:", error);
        return null;
      }
}